/**
 * Imported only once by our main.ts entry point.
 * It requires every JS file under /src and filters out spec files so that we don't have to do it manually.
 */
const requireFiles = require.context('.', true, /^(?!.*\.spec\.js$).*\.js$/);
export default requireFiles.keys().map((key) => requireFiles(key));
